import { render, staticRenderFns } from "./ApartmentDetails.vue?vue&type=template&id=71bd5b6a"
import script from "./ApartmentDetails.vue?vue&type=script&lang=ts"
export * from "./ApartmentDetails.vue?vue&type=script&lang=ts"
import style0 from "./ApartmentDetails.vue?vue&type=style&index=0&id=71bd5b6a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports